import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "Customize your own moderation rules", -1)
const _hoisted_4 = { class: "dialog-card mt-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"800px"} }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "section-title mb-1" }, "Replies set name", -1)
const _hoisted_7 = {
  key: 0,
  class: "section-subtitle"
}
const _hoisted_8 = { class: "dialog-card" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "Replies set mode", -1)
const _hoisted_10 = { class: "replies-set-mode" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Keyword based", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "info mt-2" }, " The settings will be automatically applied to all newly created campaigns containing a keyword in their names ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Asset based", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "info mt-2" }, " The settings will be applied to the selected asset, which can be BMs, Ad accounts, Pages or Campaigns ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "Replies sets", -1)
const _hoisted_16 = { class: "reply-set-item mb-3" }
const _hoisted_17 = { class: "reply-set-item__header" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "Duplicate", -1)
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "Turn off", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, "Turn on", -1)
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, "Delete", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "Trigger words", -1)
const _hoisted_26 = { class: "flex" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "Replies", -1)
const _hoisted_28 = { class: "reply-set-item__reply" }
const _hoisted_29 = { class: "dialog-actions" }

import { computed, nextTick, reactive, ref, watch } from 'vue';
import { useDialogStore } from '@/stores/dialogs';
import { useConfirmModal } from '@/stores/confirm-modal';
import { useRepliesStore } from '@/stores/replies';
import { useDataStore } from '@/stores/data';
import { copy } from '@/utils/vue';
import { useErrors } from '@/utils/use-errors';
import { incrementSimple } from '@/utils/lang';
import { useWordStatsStore } from '@/stores/word-stats';
import VInputTags from '../VInputTags.vue';
import VInput from '../VInput.vue'
import CheckOutlinedIcon from '@/components/icons/other/CheckOutlinedIcon.vue'
import BusinessesSelector from '../BusinessesSelector.vue';
import VButton from '@/components/VButton.vue'
import VRadio from '@/components/VRadio.vue'
import CopyIcon from '../icons/actions/CopyIcon.vue';
import ViewIcon from '../icons/actions/ViewIcon.vue';
import VIconButton from '../VIconButton.vue';
import CloseIcon from '../icons/navigation/CloseIcon.vue';
import VTextarea from '../VTextarea.vue';
import ViewOffIcon from '../icons/actions/ViewOffIcon.vue';
import AddCircleIcon from '../icons/actions/AddCircleIcon.vue';
import VReplySetSelect from '../VReplySetSelect.vue';
import DeleteIcon from '../icons/other/DeleteIcon.vue';
import { scrollToError } from '@/utils/scroll-top';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateAutoReplyDialog',
  props: {
    item: null,
    word: null
  },
  setup(__props: any) {

const props = __props as { item?: any, word?: string }


const values = reactive<any>({ name: "", replies_set_mode_id: 1, replies_sets: [] })

const selected = reactive<App.Assets>({})

const addNewReplySet = () => {
  values['replies_sets'].push({
    name: "Reply set",
    type_id: 1,
    replies: [ "" ],
    active: true,
    keys: []
  })
}

watch([() => values.replies_set_mode_id, () => selected], () => {
  errors.keys = null
  errors.items = null
}, { deep: true })

const sourceReplySet = ref<number | null>(null)
watch(sourceReplySet, (itemId) => {
  if (itemId === null || itemId === -1) return
  const replySet = repliesStore.replies.find(item => item.id === itemId)
  if (!replySet) return
  let name = replySet.name + " Copy"
  while(repliesStore.replies.find(item => item.name === name)) {
    name = incrementSimple(name)
  }
  Object.assign(values, JSON.parse(JSON.stringify(replySet)))

  values.name = name
})

const parentRef = ref<HTMLDivElement>()
const copyReplySet = (index: number) => {
  const _values = JSON.parse(JSON.stringify(values['replies_sets'][index]))
  _values.active = true
  values['replies_sets'].splice(index+1, 0, _values)

  nextTick(() => {
    const parent = parentRef.value?.parentElement
    const child = parentRef.value?.children[index+2]
    if (!child || !parent) return
    const height = Math.max((parent.getBoundingClientRect().height - child.getBoundingClientRect().height)/2, 0)
    const top = child.getBoundingClientRect().top + parent.scrollTop - parent.getBoundingClientRect().top - height
    parent.scrollTo({ top, behavior: "smooth" })
  })
}

const confirmModal = useConfirmModal()
const deleteReplySet = (e: MouseEvent, index: number) => {
  confirmModal.open(e, "Are you sure you would like to delete the Replies set?", () => {
    values['replies_sets'].splice(index, 1)
  })
}

const dataStore = useDataStore()

if (props.item) {
  dataStore.fillSet(selected, props.item)
  copy(values, props.item, "name", "keys", "replies_set_mode_id")
  values.replies_sets = []
  for (let replies_set of props.item.replies_sets) {
    values.replies_sets.push(JSON.parse(JSON.stringify(replies_set)))
  }
}

let wordReplySetIndex = 0
if (props.word) {
  if (values.replies_sets.length === 0) {
    addNewReplySet()
  }
  const replySet = values.replies_sets[0]
  if (!replySet.keys.includes(props.word)) {
    replySet.keys.push(props.word)
  }
  wordReplySetIndex = 0
}

const { errors, checkRequired } = useErrors(values)
const repliesStore = useRepliesStore()
const pending = ref(false)
const dialogStore = useDialogStore()
const wordStatsStore = useWordStatsStore()

const hasItems = computed(() => {
  return selected.businesses?.length || selected.pages?.length || selected.ad_accounts?.length || selected.campaigns?.length
})

const apply = async () => {
  try {
    if (!checkRequired([ "name" ])) return
    if (values.replies_set_mode_id === 1 && (!values.keys || values.keys.length === 0)) {
      errors.keys = "Enter in at least one keyword"
      return
    }
    if (values.replies_set_mode_id === 2 && !hasItems.value) {
      errors.items = "Select at least one item"
      return
    }
  
    pending.value = true
    const _values = { ...values }
    if (_values.replies_set_mode_id === 2) {
      _values.keys = []
      _values.business_ids = selected.businesses
      _values.page_ids = selected.pages
      _values.ad_account_ids = selected.ad_accounts
      _values.campaign_ids = selected.campaigns
    }

    if (props.item) {
      await repliesStore.edit(props.item.id, _values)
    } else {
      await repliesStore.create(_values)
    }
    if (props.word) {
      wordStatsStore.reset()
      wordStatsStore.requestAll()
    }
    dialogStore.close()
  } catch(e) {
    pending.value = false
  } finally {
    scrollToError(parentRef.value?.parentElement, errors)
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (props.item)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_1, "Edit Replies set"))
      : (_openBlock(), _createElementBlock("h2", _hoisted_2, "Create Replies set")),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _hoisted_6,
      (!props.item)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Copy existing Replies set or create a new one"))
        : _createCommentVNode("", true),
      (!props.item)
        ? (_openBlock(), _createBlock(VReplySetSelect, {
            key: 1,
            modelValue: sourceReplySet.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((sourceReplySet).value = $event))
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (props.item || sourceReplySet.value !== null)
        ? (_openBlock(), _createBlock(VInput, {
            key: 2,
            modelValue: values.name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((values.name) = $event)),
            error: _unref(errors).name,
            name: "name",
            class: "mt-2",
            placeholder: "Replies set name"
          }, null, 8, ["modelValue", "error"]))
        : _createCommentVNode("", true)
    ]),
    (props.item || sourceReplySet.value !== null)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", {
                class: _normalizeClass(["replies-set-mode__item", { active: values['replies_set_mode_id'] === 1 }]),
                onMousedown: _cache[3] || (_cache[3] = ($event: any) => (values['replies_set_mode_id'] = 1))
              }, [
                _createVNode(CheckOutlinedIcon, { class: "check-outlined" }),
                _hoisted_11,
                _createVNode(VInputTags, {
                  modelValue: values.keys,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((values.keys) = $event)),
                  placeholder: "Add keyword",
                  error: _unref(errors).keys,
                  name: "keys"
                }, null, 8, ["modelValue", "error"]),
                _hoisted_12
              ], 34),
              _createElementVNode("div", {
                class: _normalizeClass(["replies-set-mode__item", { active: values['replies_set_mode_id'] === 2 }]),
                onMousedown: _cache[5] || (_cache[5] = ($event: any) => (values['replies_set_mode_id'] = 2))
              }, [
                _createVNode(CheckOutlinedIcon, { class: "check-outlined" }),
                _hoisted_13,
                _createVNode(BusinessesSelector, {
                  modelValue: selected,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(selected) ? (selected).value = $event : null)),
                  error: _unref(errors).items,
                  name: "items",
                  "show-campagins": "",
                  "show-instagrams": ""
                }, null, 8, ["modelValue", "error"]),
                _hoisted_14
              ], 34)
            ])
          ]),
          _createElementVNode("div", {
            class: "dialog-card",
            ref_key: "parentRef",
            ref: parentRef
          }, [
            _hoisted_15,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(values.replies_sets, (itemValue, index) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["title", { disabled: !itemValue.active }])
                  }, "Replies set " + _toDisplayString(index+1), 3),
                  _createElementVNode("button", {
                    class: "primary",
                    onClick: ($event: any) => (copyReplySet(index))
                  }, [
                    _createVNode(CopyIcon),
                    _hoisted_19
                  ], 8, _hoisted_18),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (itemValue.active = !itemValue.active)
                  }, [
                    (itemValue.active)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(ViewOffIcon),
                          _hoisted_21
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createVNode(ViewIcon),
                          _hoisted_22
                        ], 64))
                  ], 8, _hoisted_20),
                  _createElementVNode("button", {
                    class: "red",
                    onClick: ($event: any) => (deleteReplySet($event, index))
                  }, [
                    _createVNode(DeleteIcon),
                    _hoisted_24
                  ], 8, _hoisted_23)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["reply-set-item__content", { disabled: !itemValue.active }])
                }, [
                  _hoisted_25,
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(VRadio, {
                      modelValue: itemValue.type_id,
                      "onUpdate:modelValue": ($event: any) => ((itemValue.type_id) = $event),
                      value: 1,
                      label: "Exact"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                    _createVNode(VRadio, {
                      modelValue: itemValue.type_id,
                      "onUpdate:modelValue": ($event: any) => ((itemValue.type_id) = $event),
                      value: 2,
                      label: "Contain"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                    _createVNode(VRadio, {
                      modelValue: itemValue.type_id,
                      "onUpdate:modelValue": ($event: any) => ((itemValue.type_id) = $event),
                      value: 3,
                      label: "Both"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _createVNode(VInputTags, {
                    modelValue: itemValue.keys,
                    "onUpdate:modelValue": ($event: any) => ((itemValue.keys) = $event),
                    class: "mt-2",
                    placeholder: "Add trigger word(s) here",
                    "highlight-word": index === _unref(wordReplySetIndex)? props.word: undefined
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "highlight-word"]),
                  _hoisted_27,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemValue.replies, (_, index) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createVNode(VTextarea, {
                        modelValue: itemValue.replies[index],
                        "onUpdate:modelValue": ($event: any) => ((itemValue.replies[index]) = $event),
                        placeholder: "Add reply here"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                      _createVNode(VIconButton, {
                        onClick: ($event: any) => (itemValue.replies.splice(index, 1))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(CloseIcon)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]))
                  }), 256)),
                  _createVNode(VButton, {
                    secondary: "",
                    class: "mt-1 add-variation-button",
                    onClick: ($event: any) => (itemValue.replies.push(''))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Add variation")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ], 2)
              ]))
            }), 256)),
            _createVNode(VButton, {
              secondary: "",
              class: "add-new-set-button",
              onClick: addNewReplySet
            }, {
              default: _withCtx(() => [
                _createVNode(AddCircleIcon),
                _createTextVNode(" Add new set ")
              ]),
              _: 1
            })
          ], 512)
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_29, [
      _createVNode(VButton, {
        disabled: pending.value || (!props.item && sourceReplySet.value === null),
        big: "",
        onClick: apply
      }, {
        default: _withCtx(() => [
          (props.item)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode("Save")
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode("Create")
              ], 64))
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(VButton, {
        secondary: "",
        big: "",
        onClick: _unref(dialogStore).close
      }, {
        default: _withCtx(() => [
          _createTextVNode("Cancel")
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ], 64))
}
}

})